import nl from './nl.json';
import en from './en.json';
import fr from './fr.json';
import de from './de.json';

const translations = {
  nl,
  en,
  fr,
  de
};

export default translations;
